import { StringHelpers } from "../../helpers/string-helpers";
import { ChartSettingsPopupModel } from "../chart-style/chart-settings-popup.model";
import { ChartYAxisStateModel } from "../chart-style/chart-y-axis-state-model";
import { DrawingToolsSettingModel } from "../drawing-tools/drawing-tools-setting.model";
import { EMACloudSettingsModel } from "../ema-cloud/ema-cloud-settings.model";
import { ChartType } from "../enum/chart-type.enum";
import { IndicatorType } from "../enum/indicator-type.enum";
import { Timeframe } from "../enum/timeframe.enum";
import { ManageIndicatorModel } from "../indicator/manage-indicator.model";
import { CreateLimitAlertModel } from "../limit-alert/create-limit-alert.model";
import { TemporaryStopLossType } from "../stop-loss/temporary-stop-loss.model";
import { TradeAccountModel } from "../trade/trade-account.model";
import { TradeModel } from "../trade/trade.model";
import { IChartContainer } from "./chart-container.interface";
import { IChartDataService } from "./chart-data-service.interface";

declare const winformObj: any;

export abstract class BaseChartService implements IChartDataService {
    public id = StringHelpers.newGuid();
    
    protected subscribeChartRequestingNewSymbolDataCallbacks: Array<Function> = [];
    protected subscribeInitChartDataCallbacks: Array<Function> = [];
    protected subscribeInitChartIndicatorsDataCallbacks: Array<Function> = [];
    protected subscribeInitChartComparisonsDataCallbacks: Array<Function> = [];
    protected subscribeInitChartDrawingToolsCallbacks: Array<Function> = [];
    protected subscribeInitChartDrawingToolSettingsCallbacks: Array<Function> = [];
    protected subscribeUpdate10sRefreshChartDataCallbacks: Array<Function> = [];
    protected subscribeUpdate10sRefreshIndicatorsDataCallbacks: Array<Function> = [];
    protected subscribeUpdateChartHistoryDataCallbacks: Array<Function> = [];
    protected subscribeUpdateHistoryIndicatorsDataCallbacks: Array<Function> = [];
    protected subscribeUpdateChartHistoryComparisonDataCallbacks: Array<Function> = [];
    protected subscribeRealtimeDataCallbacks: Array<Function> = [];
    protected subscribeChartStyleDataCallbacks: Array<Function> = [];
    protected subscribePnlDataCallbacks: Array<Function> = [];
    protected subscribeCurrentPositionDataCallbacks: Array<Function> = [];  
    
    protected subscribeCurrentPositionViewModelCallbacks: Array<Function> = [];

    protected subscribeTICompanyLogoDataCallbacks: Array<Function> = [];
    protected subscribeChartRequirementsDataCallbacks: Array<Function> = [];
    protected subscribeChartAllowBuyDataCallbacks: Array<Function> = [];
    protected subscribeChartAllowSellDataCallbacks: Array<Function> = [];
    protected subscribeCompanyLogoDataCallbacks: Array<Function> = [];
    protected subscribeDrawTradeOrdersDataCallbacks: Array<Function> = [];
    protected subscribeDrawOrderExecutionDataCallbacks: Array<Function> = [];
    protected subscribePriceAlertsDataCallbacks: Array<Function> = [];
    protected subscribePriceAlertsImageDataCallbacks: Array<Function> = [];
    protected subscribeEarningNotificationDataCallbacks: Array<Function> = [];
    protected subscribeHaltedNotificationDataCallbacks: Array<Function> = [];
    protected subscribeSwingExitDataCallbacks: Array<Function> = [];
    protected subscribSmartRiskDataCallbacks: Array<Function> = [];
    protected subscribHeartStatusDataCallbacks: Array<Function> = [];
    protected subscribeDrawEarningNotificationDataCallbacks: Array<Function> = [];
    protected subscribeLastPriceDataCallbacks: Array<Function> = [];
    protected subscribeDrawTradePriceAnnotationsCallbacks: Array<Function> = [];
    protected subscribeWindowMinimizeUpdateCallbacks: Array<Function> = [];
    protected subscribeEmojiDataCallbacks: Array<Function> = [];
    protected subscribeInitChartIndicatorsTIQDataCallbacks: Array<Function> = [];
    protected subscribe_SingleStockWindowDatas: Array<Function> = [];
    protected subscribe_CompanyProfileDatas: Array<Function> = [];
    protected subscribe_FocusSymbolLookupRequests: Array<Function> = [];
    protected subscribe_TradeAccountsDatas: Array<Function> = [];
    protected subscribe_AIDatas: Array<Function> = [];
    protected subscribe_LastTradeAccountsDatas: Array<Function> = [];
    protected subscribe_SimpleTiDataPointsDatas: Array<Function> = [];
    protected subscribe_AuthorizationsDatas: Array<Function> = [];
    protected subscribe_AddTemporaryStopLossDatas: Array<Function> = [];
    protected subscribe_AlertsColumnsDatas: Array<Function> = [];
    protected subscribe_AlertsDatas: Array<Function> = [];
    protected subscribe_SupportResistanceLinesDatas: Array<Function> = [];
    protected subscribe_NextSupportResistanceLinesDatas: Array<Function> = [];
    protected subscribe_OpenIndicatorManagerDatas: Array<Function> = [];
    protected subscribe_RemoveTemporaryStopLossDatas: Array<Function> = [];
    protected subscribe_OrderRejectionMessageDatas: Array<Function> = [];
    
    protected symbol = '';

    protected base: IChartContainer;

    constructor(base: IChartContainer) {
        this.base = base;
    }

    public getSymbolLabel(): string {
        return '';
    }

    public subscribeChartRequestingNewSymbolData(callback: Function) {
    }

    public subscribeInitChartData(callback: Function) {
    }

    public subscribeInitChartIndicatorsData(callback: Function) {
    }

    public subscribeInitChartIndicatorsTIQData(callback: Function) {
    }

    public subscribeInitChartComparisonsData(callback: Function) {
    }

    public subscribeInitChartDrawingTools(callback: Function) {
    }

    public subscribeInitChartDrawingToolSettings(callback: Function) {
    }

    public subscribeUpdate10sRefreshChartData(callback: Function) {
    }

    public subscribeUpdate10sRefreshIndicatorsData(callback: Function) {
    }

    public subscribeUpdateChartHistoryData(callback: Function) {
    }

    public subscribeUpdateHistoryIndicatorsData(callback: Function) {
    }

    public subscribeUpdateChartHistoryComparisonData(callback: Function) {
    }

    public subscribeRealtimeData(callback: Function) {
    }

    public subscribeChartStyleData(callback: Function) {
    }

    public subscribeCompanyLogoData(callback: Function) {
    }

    public subscribePnlData(callback: Function) {
    }

    public subscribeCurrentPositionData(callback: Function) {
    }

    public subscribeCurrentPositionViewModel(callback: Function) {
    }

    public subscribeTICompanyLogoData(callback: Function) {
    }

    public subscribeChartRequirementsData(callback: Function) {
    }

    public subscribeChartAllowBuyData(callback: Function) {
    }

    public subscribeChartAllowSellData(callback: Function) {
    }

    public subscribeDrawTradeOrdersData(callback: Function) {
    }

    public subscribeDrawOrderExecutionData(callback: Function) {
    }

    public subscribePriceAlertsData(callback: Function) {
    }

    public subscribePriceAlertsImageData(callback: Function) {
    }

    public subscribeEarningNotificationData(callback: Function) {
    }

    public subscribeHaltedNotificationData(callback: Function) {
    }

    public subscribeLastPriceData(callback: Function) {
    }

    public subscribeDrawTradePriceAnnotations(callback: Function) {
    }

    public subscribeWindowMinimizeUpdate(callback: Function) {
    }

    public subscribeSwingExitData(callback: Function) {
    }

    public subscribeSmartRiskData(callback: Function) {
    }

    public subscribeHeartStatusData(callback: Function) {
    }

    public subscribeDrawEarningNotificationData(callback: Function) {
    }

    public subscribeEmojiData(callback: Function) {
    }

    public subscribe_SingleStockWindowData(callback: Function) {
    }

    public subscribe_CompanyProfileData(callback: Function) {
    }

    public subscribe_FocusSymbolLookupRequest(callback: Function) {
    }

    public subscribe_TradeAccounts(callback: Function) {
    }
    
    public notifyTradeAccountSubscribers(model: TradeAccountModel[]) {
        for (const callback of this.subscribe_TradeAccountsDatas) {
            callback(model);
        }
    }

    public subscribe_AIData(callback: Function) {
    }
    
    public subscribe_LastTradeAccounts(callback: Function) {
    }

    public subscribe_SimpleTiDataPoints(callback: Function) {
    }
    
    public subscribe_Authorizations(callback: Function) {
    }

    public subscribe_AddTemporaryStopLoss(callback: Function) {
    }

    public subscribe_AlertsColumns(callback: Function) {
    }

    public subscribe_AlertsData(callback: Function) {
    }
    
    public subscribe_SupportResistanceLinesData(callback: Function) {
    }
    
    public subscribe_NextSupportResistanceLinesData(callback: Function) {
    }
    
    public subscribe_OpenIndicatorManager(callback: Function) {
    }
    
    public subscribe_RemoveTemporaryStopLoss(callback: Function) {
    }

    public subscribe_OrderRejectionMessage(callback: Function) {
    }

    public notifyChartHideContextMenu() {
    }

    public requestHistory() {
    }

    public requestOpenSymbolLookup(symbol: string) {
    }

    public requestSimpleTiDataPoints(symbol: string, timeframe: Timeframe, premarket: boolean, postmarket: boolean, rowCount: number) {
    }

    public requestNewSymbol(symbol: string) {
    }

    public requestNewTimeframe(timeframe: Timeframe) {
    }

    public requestNewChartType(chartType: ChartType) {
    }

    public requestBuy() {
    }

    public requestSell() {
    }

    public requestInitiateChartTrade(price: number, isLong: boolean, quoteType?: string, account?: string, quoteQuantity?: number) {
    }

    public requestUpdateChartTrade(orderId: string, price: number) {
    }

    public requestUpdateChartTradeV2(orderId: string, price: number) {
    }

    public requestUpdateLimitAlert(id: string, price: number) {
    }

    public requestRemoveChartTrade(orderId: string) {
    }

    public requestRemoveChartTradeV2(orderId: string) {
    }
    
    public hasRemoveChartTradeV2(): boolean {
        return false;
    }

    public requestRemoveLimitAlert(id: string) {
    }

    public requestUpdateLastPriceClicked(price: number) {
    }

    public requestAddIndicators() {
    }

    public requestAddPriceAlert() {
    }

    public requestCreatePriceAlert (model: CreateLimitAlertModel) { 
    }

    public requestAddAVWap(xValue: number) {
    }

    public requestAddComparisonSymbols(activeTab: number) {
    }

    public requestOpenComparisonSymbolLookup(symbol: string) {
    }

    public requestSetHeartLikedStatus() {
    }

    public requestCameraTakeScreenshot() {
    }

    public requestSetZoomLevel(clientZoomLevel: number) {
    }

    public requestSetFirstVisibleStartTimeT(startTimeT: number) {
    }

    public requestSetPnPState(position: string, expanded: boolean, timeframe: Timeframe) {
    }

    public requestMouseEnter() {
    }

    public requestMouseLeave() {
    }

    public requestSaveDrawingTools(data: any[]) {
    }

    public requestSaveDrawingToolSettings(data: DrawingToolsSettingModel) {
    }

    public requestSaveHighChartIndicators(highChartIndicators: IndicatorType[]) {
    }

    public requestSaveExtraFutureBarCount(extraBarCount: number) {
    }

    public requestSaveSingleStockWindowState(state: string) {
    }

    public requestSaveCompanyProfileState(state: string) {
    }

    public requestBuySellButtonsHover(hoverOnBuy: boolean, hoverOnSell: boolean) {
    }
    
    public requestManualTrade(model: TradeModel) {
    }
    
    public requestOpenRobotTrade() {
    }
    
    public requestOpenAllChartOptions() {
    }
    
    public requestSaveTradeUIState(open: boolean, top: number | null, left: number | null, tif: string, account: string) {
    }
    
    public requestSaveEMACloudSettings(settings: EMACloudSettingsModel) {
    }

    public requestSaveChartSettingsPopupModel(model: ChartSettingsPopupModel) {
    }

    public requestSaveYAxisHeightState(model: ChartYAxisStateModel) {
    }

    public requestRemoveTemporaryStopLoss(accountName: string, stopType: TemporaryStopLossType | null) {
    }

    public requestUpdateTemporaryStopLoss(accountName: string, stopType: TemporaryStopLossType | null, price: number) {
    }

    public requestUpdateTemporaryStopLossV2(accountName: string, stopType: TemporaryStopLossType | null, price: number) {
    }

    public chartReady() {
    }

    protected winformObjHasValue() {
        return typeof (winformObj) != 'undefined' && !!winformObj;
    }
    
    public getWindowFormTimeFrame(timeframe: Timeframe): {formTimeFrame: Timeframe; formRange: Timeframe;}  {
        let formTimeFrame = timeframe;
        let formRange = timeframe;
        if (timeframe == Timeframe.OneMonthRange) {
            formTimeFrame = Timeframe.Day;
            formRange = Timeframe.OneMonthRange;
        } else if (timeframe == Timeframe.SixMonthRange) {
            formTimeFrame = Timeframe.Day;
            formRange = Timeframe.SixMonthRange;
        } else if (timeframe == Timeframe.YearToDateRange) {
            formTimeFrame = Timeframe.Day;
            formRange = Timeframe.YearToDateRange;
        } else if (timeframe == Timeframe.OneYearRange) {
            formTimeFrame = Timeframe.Day;
            formRange = Timeframe.OneYearRange;
        } else if (timeframe == Timeframe.FiveYearRange) {
            formTimeFrame = Timeframe.Month;
            formRange = Timeframe.FiveYearRange;
        }

        return {
            formTimeFrame: formTimeFrame,
            formRange: formRange
        };
    }

    public requestSaveIndicatorsForIndicatorManager(items: Array<ManageIndicatorModel>) {}
    
    public getSavedIndicatorsForIndicatorManager(displayVolumeIndicator?: boolean): Array<ManageIndicatorModel> {
        return [];
    }
}